<template>
  <div class="absolute inset-0 z-10 flex items-center justify-center">
    <div class="pointer-events-none absolute inset-0 bg-brand-primary-teal-50/75"></div>
    <dialog
      open
      class="mx-0 max-h-full overflow-auto rounded-lg bg-brand-primary-teal-400 p-4 text-white shadow-md sm:mx-8"
    >
      <h2 class="mb-4 font-medium">
        Are you sure you want to cancel your edit and discard any changes you've made?
      </h2>
      <div class="flex justify-end gap-4">
        <button
          class="cursor-pointer rounded-md bg-white px-8 py-2 text-sm font-medium text-brand-primary-teal-400 sm:px-6"
          @click="$emit('no')"
        >
          No<span class="hidden sm:inline">, keep editing</span>
        </button>
        <button
          class="cursor-pointer rounded-md bg-white px-8 py-2.5 text-sm font-medium text-brand-primary-teal-400 sm:px-6 sm:py-2"
          @click="$emit('yes')"
        >
          Yes<span class="hidden sm:inline">, discard changes</span>
        </button>
      </div>
    </dialog>
  </div>
</template>
